<!--
 * @description: header
 * @Author: wxy
 * @Date: 2020-02-11 12:03:04
 -->
<template>
  <div class="header-container">
    <div class="header-inner">
      <img class="logo" src="@/assets/img/dashboard/logo.png" />
      <span class="title">图枢</span>
      <span class="btn download" @click="clickDownload">下载</span>
      <span class="btn login" @click="webLogin">管理后台</span>
    </div>
    <transition name="el-fade-in-linear">
      <div class="header-container isFixed" v-show="isFixed">
        <div class="header-inner">
          <img class="logo" src="@/assets/img/dashboard/logo.png" />
          <span class="title">图枢</span>
          <span class="btn download" @click="clickDownload">下载</span>
          <span class="btn login" @click="webLogin">管理后台</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      isFixed: false
    }
  },
  methods: {
    show() {
      this.isFixed = true
    },
    hide() {
      this.isFixed = false
    },
    clickDownload() {
      this.$emit('clickDownload')
    },
    webLogin() {
      window.open('https://teamlink.unicloud.com/tenant-mss/#/login', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.header-container {
  width: 100%;
  height: 63px;
  line-height: 63px;
  position: relative;
  text-align: center;
  .header-inner {
    width: 1000px;
    margin: 0 auto;
    color: #fff;
  }
  .logo,
  .title {
    float: left;
  }
  .logo {
    width: 36px;
    margin-right: 15px;
    margin-top: 15px;
  }
  .title {
    font-size: 25px;
  }
  .btn {
    float: right;
    padding: 0px 10px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-top: 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .download {
    color: #4c3eff;
    background: #fff;
    margin-left: 15px;
  }
}
.isFixed {
  position: fixed;
  top: 0;
  left: 0;
  color: #0085dd;
  z-index: 99999;
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  .login {
    color: #2053cd;
    border-color: #2053cd;
  }
  .download {
    color: #fff;
    background: #2053cd;
    margin-left: 15px;
  }
  .title {
    border-color: #2053cd;
    color: #2053cd;
  }
}
@media (max-width: 770px) {
  .header-container {
    height: 0;
    .mobile-header {
      display: none;
    }
    .header-inner {
      width: 90%;
    }
    .header-container{
      height: 63px;
    }
  }
}
</style>
